export function removeDuplicates(arr) {
  return arr.filter(
    (currItem, index) =>
      arr.findIndex((item) => currItem.id === item.id) === index
  );
}
